import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

const PaperProgress = () => {
    //Sujay 9/6/2025 Chnaging the platfrom selection I access from it the localstorage
    //const [platforms, setPlatforms] = useState([]);
    const Platform = localStorage.getItem("platformID");
    //const [selectedPlatformId, setSelectedPlatformId] = useState('');
    const [progressData, setProgressData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const API = process.env.REACT_APP_API_BASE_URL;

    //sujay adding the project progress by logged in user and platfrom
    useEffect(() => {
        const authorID = localStorage.getItem('AuthorID');
        axios.get(`${API}/api/project-progress/${authorID}/${Platform}`)
            .then(res => setProgressData(res.data))
            .catch(err => console.error(err));
    }, []);

    // useEffect(() => {
    //     // Load platforms
    //     axios.get('http://localhost:5000/api/host/platforms')
    //         .then(res => setPlatforms(res.data))
    //         .catch(err => console.error(err));
    // }, []);

    // useEffect(() => {
    //     if (selectedPlatformId) {
    //         const authorID = localStorage.getItem('AuthorID');
    //         axios.get(`http://localhost:5000/api/project-progress/${authorID}/${selectedPlatformId}`)

    //             .then(res => setProgressData(res.data))
    //             .catch(err => console.error(err));
    //     }
    // }, [selectedPlatformId]);

    const activities = [
        { key: 'PaperSubmitted', label: 'Paper Submitted' },
        { key: 'SubmissionRegistered', label: 'Submission Registered' },
        { key: 'ReviewerAssigned', label: 'Reviewer Assigned' },
        { key: 'CommentsShared', label: 'Comments Shared' },
        { key: 'RepliesUpload', label: 'Replies Uploaded' },
        { key: 'RevisionUpload', label: 'Revision Uploaded' },
        { key: 'SubmissionAccepted', label: 'Submission Accepted' },
        { key: 'Scheduled', label: 'Scheduled' },
        { key: 'Released', label: 'Released' }
    ];

    // Filter data by search term (SubmissionTitle)
    const filtered = progressData.filter(item => 
        item.SubmissionTitle.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="container mt-5 ml-2">
            <h3 className="page-title mb-4">Project Progress</h3>

            {/* search input */}
            <div className="mb-4">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Submission Title"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            {/* sujay 9/6/2025 hiding the select platform  */}
            {/* Platform Selection */}
            {/* <div className="mb-4">
                <label className="form-label fw-semibold">Select Platform</label>
                <select
                className="form-select shadow-sm"
                value={selectedPlatformId}
                onChange={(e) => setSelectedPlatformId(e.target.value)}
            >
                <option value="">-- Select Platform --</option>
                {platforms.map((p) => (
                    <option key={p.PlatformID} value={p.PlatformID}>
                        {p.PlatformName}
                    </option>
                ))}
            </select>
            </div> */}

            {/* Progress Display */}
            {filtered.length > 0 && (
                <div className="table-responsive">
                    <table className="table table-bordered table-hover align-middle text-center">
                        <thead className="table-primary">
                            <tr>
                                <th scope="col">Submission Title</th>
                                {activities.map((act, idx) => (
                                    <th scope="col" key={idx}>{act.label}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map((submission) => (
                                <tr key={submission.SubmissionID}>
                                    <td className="text-start">{submission.SubmissionTitle}</td>
                                    {activities.map((act, idx) => (
                                        <td key={idx}>
                                            <span className={`badge rounded-pill px-3 py-2 fs-6 ${submission[act.key] === 1 ? 'bg-success' : 'bg-danger'}`}>
                                                <FontAwesomeIcon
                                                    icon={submission[act.key] === 1 ? faCheck : faTimes}
                                                />
                                            </span>
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {filtered.length === 0 && (
                <div className="text-center mt-4">
                    No submissions match your search.
                </div>
            )}
        </div>
    );
};

export default PaperProgress;
